import { useQueries, useQuery } from 'react-query';
import { Options } from '@frontend/fetch';
import { LimitedSchemaQueryOptions } from '@frontend/react-query-helpers';
import { SchemaEmailDomainV1Service } from '../service';
import { GetDomainsByOrgIDIO } from '../types';

export const getGetDomainsByOrgIDQueryKey = (req: GetDomainsByOrgIDIO['input']) =>
  ['EmailDomainV1', 'GetDomainsByOrgID', req.orgId] as const;
type QueryKey = ReturnType<typeof getGetDomainsByOrgIDQueryKey>;

export const useGetDomainsByOrgIDQuery = <E = unknown, D = GetDomainsByOrgIDIO['output']>(
  req: GetDomainsByOrgIDIO['input'],
  options?: LimitedSchemaQueryOptions<GetDomainsByOrgIDIO, E, D, QueryKey>,
  httpOptions?: Options
) =>
  useQuery<GetDomainsByOrgIDIO['output'], E, D, QueryKey>({
    queryKey: getGetDomainsByOrgIDQueryKey(req),
    queryFn: () => SchemaEmailDomainV1Service.GetDomainsByOrgID(req, httpOptions),
    ...options,
  });

export const useGetDomainsByOrgIDQueries = <E = unknown, D = GetDomainsByOrgIDIO['output']>(
  argsArr: {
    req: GetDomainsByOrgIDIO['input'];
    options?: LimitedSchemaQueryOptions<GetDomainsByOrgIDIO, E, D, QueryKey>;
    httpOptions?: Options;
  }[]
) =>
  useQueries(
    argsArr.map(({ req, options, httpOptions }) => ({
      queryKey: getGetDomainsByOrgIDQueryKey(req),
      queryFn: () => SchemaEmailDomainV1Service.GetDomainsByOrgID(req, httpOptions),
      ...options,
    }))
  ) as ReturnType<typeof useGetDomainsByOrgIDQuery<E, D>>[];
